import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { FiAlignRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import { BiSearch } from "react-icons/bi";
import { Container } from "@mui/material";
import "./Navbar.css";
import { images } from "../../config/images";
import {
  categoryData,
  productData,
  searchData,
  setting,
} from "../../config/services";
import { slugify } from "../../utils/slugify";

function Navbar({ headerAPIData }) {
  const [activeNavLink, setActiveNavLink] = useState(false);
  const [containerClass, setContainerClass] = useState("container-fluid");
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const [subData, setSubData] = useState([]);
  const [searchAPIData, setSearchAPIData] = useState([]);
  const [searchHistory, setSearchHistory] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const toggleOverlay = () => {
    setIsOverlayVisible(!isOverlayVisible);
    setSearchAPIData([]);
    setSearchInput("");
    setIsDropdownVisible(false); // Close dropdown when overlay is toggled
  };

  const handleSearch = () => {
    if (searchInput) {
      // Add search input to the search history and clear the input
      setSearchHistory([searchInput, ...searchHistory]);
      setSearchInput("");
      setIsDropdownVisible(true); // Show dropdown after searching
    }
  };
  const handleSearchInput = (e) => {
    setSearchInput(e.target.value);
  };

  const handleResize = () => {
    if (window.innerWidth >= 1200) {
      setContainerClass("container");
    } else {
      setContainerClass("container-fluid");
    }
  };

  useEffect(() => {
    handleSubData();
  }, []);

  useEffect(() => {
    handlesearchData();
  }, [searchInput]);

  const handleSubData = async () => {
    try {
      const resp = await categoryData();
      if (resp.data.code == 200 || resp.data.code == 201) {
        setSubData(resp.data.responseBody);
      }
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };

  const handlesearchData = async () => {
    if (searchInput !== "") {
      const params = {
        search: searchInput,
      };
      try {
        const resp = await searchData(params);
        if (resp.data.code === 200 || resp.data.code === 201) {
          setSearchAPIData(resp.data.responseBody);
        }
      } catch (error) {
        setSearchAPIData([]);
        console.log("handlesubmit", error);
      }
    }
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const navigate = useNavigate();

  const location = useLocation();

  const closeOffcanvas = () => {
    const offcanvasElement = document.querySelector(".offcanvas");
    const offcanvasInstance =
      window.bootstrap.Offcanvas.getInstance(offcanvasElement);
    offcanvasInstance.hide();
  };

  const handleNavLinkClick = (path) => {
    navigate(path);

    closeOffcanvas();


    const activeLinks = document.querySelectorAll(".nav-link.active");
    activeLinks.forEach((link) => link.classList.remove("active"));

    const clickedLink = document.querySelector(`.nav-link[href="${path}"]`);
    if (clickedLink) {
      clickedLink.classList.add("active");
    }
  };
  const categoryId = localStorage.getItem("category_id");
  const subcategoryId = localStorage.getItem("subcategory_id");

  const handleSearchClick = async (result) => {
    const params = {
      categories_id: result.category_id,
      subcategories_id: result.id,
    };

    const category = subData.find(cat => cat.id == result.category_id);
    const categorySlug = slugify(category?.title || '');

    try {
      const resp = await productData({ params });

      if (resp.data.code === 200 || resp.data.code === 201) {

        const queryParams = new URLSearchParams({
          isSearch: true,
          subcategories_id: result.id,
        });

        const newUrl = `/division/${categorySlug}?${queryParams.toString()}`;

        navigate(newUrl, { state: { category_id: result.category_id, navTitle: category?.title } });
        setIsOverlayVisible(false);
      }
    } catch (error) {
      const queryParams = new URLSearchParams({
        isSearch: true,
        subcategories_id: result.id,
      });
      const newUrl = `/division/${categorySlug}?${queryParams.toString()}`;

      navigate(newUrl, { state: { category_id: result.category_id, navTitle: category?.title } });
      setIsOverlayVisible(false);
      console.log("Error in handleProduct:", error);
    }
  };

    useEffect(() => {
      const dropdowns = document.querySelectorAll('.dropdown');
      
      const handleMouseLeave = (event) => {
        const dropdown = event.currentTarget;
        if (!dropdown) return;
        
        const dropdownToggle = dropdown.querySelector('.dropdown-toggle');
        if (!dropdownToggle) return;
        
        try {
          const bsDropdown = window.bootstrap.Dropdown.getInstance(dropdownToggle);
          if (bsDropdown) {
            bsDropdown.hide();
          }
        } catch (error) {
          console.log('Error handling dropdown:', error);
        }
      };
  
      dropdowns.forEach(dropdown => {
        if (dropdown) {
          dropdown.addEventListener('mouseleave', handleMouseLeave);
        }
      });
  
      return () => {
        dropdowns.forEach(dropdown => {
          if (dropdown) {
            dropdown.removeEventListener('mouseleave', handleMouseLeave);
          }
        });
      };
    }, []);
  return (
    <>
      <nav class="navbar common-sec">
        <div className="navbar-right-wrap">
          <NavLink className="navbar-brand" to="/">
            <img src={images.logo} alt="logo" className="navbar-logo" />
          </NavLink>
        </div>
        <div className="navbar-search-icon">
          <div className="search-icon d-xl-none" onClick={toggleOverlay}>
            <BiSearch className="nav-link" />
          </div>

          <button
            class="navbar-toggler d-xl-none"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
          >
            <FiAlignRight className="toggler-iscon" />
          </button>
        </div>

        <div className="navbar-wrap">
          <div className="navbar-text1 nav-elements">
            <ul className="nav-link-wrap">
              <li className="nav-item active">
                <NavLink to="/" className={`nav-link`}>
                  Home
                </NavLink>
              </li>
              <li className="nav-item dropdown">
                <NavLink className={`nav-link`} to="/aboutus">
                  About Us
                </NavLink>
              </li>

              <li className="nav-item dropdown">
                <NavLink
                  className={({ isActive }) =>
                    isActive || location.pathname.startsWith("/division")
                      ? "nav-link active dropdown-toggle"
                      : "nav-link dropdown-toggle"
                  }
                  to="/division"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="true"
                  aria-expanded="false"
                  style={{ display: "flex", alignItems: "center" }} // Ensures proper alignment
                >
                  Division
                  <i
                    className="fa-solid fa-chevron-down"
                    style={{
                      marginLeft: "8px", // Add spacing between text and icon
                      fontSize: "12px", // Adjust icon size if necessary
                    }}
                  ></i>
                </NavLink>

                <ul className="dropdown-menu" aria-labelledby="navbarDropdown" data-bs-popper="none">
                  {subData.length
                    ? subData.map((e) => {
                      return (
                        <li style={{ cursor: "pointer" }}>
                          <a
                            className="dropdown-item"
                            onClick={() =>
                              navigate(`/division/${slugify(e.title)}`, {
                                state: {
                                  navTitle: e.title,
                                  category_id: e.id,
                                },
                              })
                            }
                          >
                            {e.title}
                          </a>
                        </li>
                      );
                    })
                    : []}
                </ul>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/gallery"
                  className={({ isActive }) =>
                    isActive || location.pathname.startsWith("/gallery")
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  Gallery
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/blog"
                  className={({ isActive }) =>
                    isActive || location.pathname.startsWith("/blog")
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  Blog
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/career"
                  className={({ isActive }) =>
                    isActive || location.pathname.startsWith("/applynow")
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  Career
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/contactus" className="nav-link">
                  Contact Us
                </NavLink>
              </li>
              <li className="nav-item">
                <div className="search-icon" onClick={toggleOverlay}>
                  <BiSearch className="nav-link " />
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* ===============  offcanvas =============== */}

        <div
          class="offcanvas offcanvas-start"
          tabindex="-1"
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
        >
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasNavbarLabel">
              <img src={images.logo} alt="logo" className="navbar-logo" />
            </h5>
            <button
              type="button"
              class="text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <IoMdClose className="offcanvas-close-btn" />
            </button>
          </div>

          <div class="offcanvas-body nav-elements">
            <ul class="navbar-nav">
              <li className="nav-item">
                <a
                  // className="nav-link"
                  className={
                    location.pathname.startsWith("/")
                      ? "nav-link active"
                      : "nav-link"
                  }
                  onClick={() => handleNavLinkClick("/")}
                >
                  Home
                </a>
              </li>

              <li className="nav-item">
                <a
                  // className="nav-link"
                  className={
                    location.pathname.startsWith("/aboutus")
                      ? "nav-link active"
                      : "nav-link"
                  }
                  onClick={() => handleNavLinkClick("/aboutus")}
                >
                  About Us
                </a>
              </li>

              <li className="nav-item dropdown">
                <a
                  //  className="nav-link"
                  className={
                    location.pathname.startsWith("/division")
                      ? "nav-link active"
                      : "nav-link"
                  }
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Division
                </a>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  {subData.length
                    ? subData.map((e) => {
                      return (
                        <li>
                          <a
                            className="dropdown-item"
                            onClick={() => {
                              navigate(`/division/${slugify(e.title)}`, {
                                state: { navTitle: e.title, category_id: e.id },
                              });
                              closeOffcanvas(); // Close menu after clicking
                            }}
                          >
                            {e.title}
                          </a>
                        </li>
                      );
                    })
                    : []}
                </ul>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">

                  {subData.length
                    ? subData.map((e) => {
                      return (
                        <li style={{ cursor: "pointer" }}>
                          <a
                            className="dropdown-item"
                            onClick={() => {
                              navigate(`/division/${slugify(e.title)}`, {
                                state: { navTitle: e.title, category_id: e.id },
                              });
                              closeOffcanvas(); // Close menu after clicking
                            }}
                          >
                            {e.title}
                          </a>
                        </li>
                      );
                    })
                    : []}
                </ul>
                {/* <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                 
                  >
                    {subData.length
                      ? subData.map((e) => {
                          return (
                            <li style={{ cursor: "pointer" }}>
                              <a
                                className="dropdown-item"
                                onClick={() =>
                                  navigate(`/division/${e.id}`, {
                                    state: { navTitle: e.title },
                                  })
                                }
                              >
                                {e.title}
                              </a>
                            </li>
                          );
                        })
                      : []}
                  
                </ul> */}
              </li>

              <li className="nav-item">
                <a
                  //  className="nav-link"
                  className={
                    location.pathname.startsWith("/gallery")
                      ? "nav-link active"
                      : "nav-link"
                  }
                  onClick={() => handleNavLinkClick("/gallery")}
                >
                  Gallery
                </a>
              </li>
              <li className="nav-item">
                <a
                  // className="nav-link"
                  className={
                    location.pathname.startsWith("/blog")
                      ? "nav-link active"
                      : "nav-link"
                  }
                  onClick={() => handleNavLinkClick("/blog")}
                >
                  Blog
                </a>
              </li>
              <li className="nav-item">
                <a
                  // className="nav-link"
                  className={
                    location.pathname.startsWith("/applynow") ||
                      location.pathname.startsWith("/career")
                      ? "nav-link active"
                      : "nav-link"
                  }
                  onClick={() => handleNavLinkClick("/career")}
                >
                  Career
                </a>
              </li>
              <li className="nav-item">
                <a
                  // className="nav-link"
                  className={
                    location.pathname.startsWith("/contactus")
                      ? "nav-link active"
                      : "nav-link"
                  }
                  onClick={() => handleNavLinkClick("/contactus")}
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        <>
          {isOverlayVisible && (
            <div className="overlay" onClick={toggleOverlay} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Escape" && toggleOverlay()} aria-label="Close search">
              <div className="overlay-content" onClick={(e) => e.stopPropagation()}>
                <div className="search-container">
                  <div>
                    <BiSearch className="search-icon-left" />
                    <input
                      type="text"
                      className="search-input"
                      value={searchInput}
                      onChange={handleSearchInput}
                      placeholder="Search here..."
                    />
                  </div>
                  <button className="search-button" onClick={handleSearch}>
                    <BiSearch className="search" /> Search
                  </button>
                </div>

                {searchAPIData.length > 0 && (
                  <div className="search-results-dropdown">
                    {searchAPIData.map((result) => (
                      <div
                        key={result.id}
                        className="search-result-item"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleSearchClick(result)}
                      >
                        {result.title}{" "}
                      </div>
                    ))}
                  </div>
                )}

                <button className="close-button" onClick={toggleOverlay}>
                  <IoMdClose />
                </button>
              </div>
            </div>
          )}
        </>
      </nav>
    </>
  );
}

export default Navbar;
